import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { getTypographyStyles } from '../../../Typography/Typography.styles.js';

var _templateObject;
var Labels = styled.ul(function (_ref) {
  var _ref$theme = _ref.theme,
    opacity = _ref$theme.opacity,
    sizing = _ref$theme.sizing,
    $isDisabled = _ref.$isDisabled,
    $isReversed = _ref.$isReversed;
  return {
    display: 'block',
    height: sizing.medium,
    margin: "0 ".concat(sizing.small),
    opacity: $isDisabled ? opacity.disabled : undefined,
    position: 'relative',
    transform: $isReversed ? "rotate(180deg)" : undefined
  };
});
var Label = styled(getTypographyStyles('bodySmall')).attrs(function (_ref2) {
  var _ref2$$min = _ref2.$min,
    $min = _ref2$$min === void 0 ? 0 : _ref2$$min,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? 0 : _ref2$value,
    _ref2$$scaleFactor = _ref2.$scaleFactor,
    $scaleFactor = _ref2$$scaleFactor === void 0 ? 1 : _ref2$$scaleFactor,
    label = _ref2.label;
  return {
    'aria-label': label,
    as: 'li',
    style: {
      left: (value - $min) * $scaleFactor
    }
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  position: absolute;\n  transform: ", ";\n  top: 0;\n\n  ", "\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colours.ink.primary.main;
}, function (_ref4) {
  var $isReversed = _ref4.$isReversed;
  return $isReversed ? "rotate(180deg) translateX(50%)" : "translateX(-50%)";
}, function (_ref5) {
  var _ref5$$hasNotch = _ref5.$hasNotch,
    $hasNotch = _ref5$$hasNotch === void 0 ? false : _ref5$$hasNotch,
    theme = _ref5.theme;
  return $hasNotch && "\n    &::before {\n      background-color: ".concat(theme.colours.canvas.primary.main, ";\n      content: '';\n      display: block;\n      height: ").concat(theme.sizing.xsmall, ";\n      margin-left: ").concat(theme.sizing.xsmall, "; \n      width: 1px;\n    }\n  ");
});

export { Label, Labels };
//# sourceMappingURL=Labels.styles.js.map
